function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  className: "svg-mono",
  fill: "#00B3E6",
  d: "M9.844,57.952 L9.844,48.352 L53.044,48.352 L53.044,57.952 L9.844,57.952 Z M43.868,9.952 L19.016,9.952 L31.444,27.152 L43.868,9.952 L43.868,9.952 Z M62.644,0.352 L31.444,43.552 L0.244,0.352 L62.644,0.352 Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "svg-mono",
  fill: "#000",
  fillRule: "nonzero",
  points: "100.72 48.356 100.72 32.948 85.944 32.948 85.944 48.356 77.036 48.356 77.036 9.956 85.944 9.956 85.944 24.984 100.72 24.984 100.72 9.948 109.628 9.948 109.628 48.348"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "svg-mono",
  fill: "#000",
  fillRule: "nonzero",
  points: "120.868 48.356 120.868 9.956 145.2 9.956 145.2 18.12 129.776 18.12 129.776 24.984 143.82 24.984 143.82 32.74 129.776 32.74 129.776 40.232 145.2 40.232 145.2 48.356"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "svg-mono",
  fill: "#000",
  fillRule: "nonzero",
  points: "155.812 48.356 155.812 9.956 164.716 9.956 164.716 40.24 180.124 40.24 180.124 48.364"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "svg-mono",
  fill: "#000",
  fillRule: "nonzero",
  points: "187.6 48.356 187.6 9.956 196.52 9.956 196.52 40.24 211.924 40.24 211.924 48.364"
}), /*#__PURE__*/React.createElement("path", {
  className: "svg-mono",
  fill: "#000",
  fillRule: "nonzero",
  d: "M237.052 48.984C225.156 48.984 217.56 40.444 217.56 29.176 217.56 17.908 225.524 9.316 237.42 9.316 249.316 9.316 256.912 17.86 256.912 29.176 256.912 40.492 248.896 48.984 237.052 48.984zM237.2 17.284C231.124 17.284 227.036 22.26 227.036 29.176 227.036 36.092 231.124 41.072 237.2 41.072 243.276 41.072 247.368 36.04 247.368 29.176 247.368 22.312 243.288 17.284 237.2 17.284zM276.16 48.984C271.812 48.984 266.56 47.256 263.22 45.052L265.68 36.984C268.772 39.236 272.808 40.704 276.424 40.704 279.568 40.704 280.772 39.236 280.772 37.352 280.772 35.352 279.776 33.996 273.908 31.64 267.148 28.916 264.8 24.984 264.8 20.372 264.8 14.772 269.356 9.316 278.316 9.316 282.508 9.316 286.808 10.784 289.06 12.304L286.8 20.268C284.596 18.748 281.036 17.124 278.308 17.124 275.06 17.124 273.752 18.644 273.752 20.216 273.752 22.732 275.688 23.572 280.512 25.612 287.688 28.652 289.836 32.112 289.836 37.036 289.836 43.168 285.384 48.984 276.16 48.984z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "svg-mono",
  fill: "#000",
  fillRule: "nonzero",
  points: "299.388 48.356 299.388 9.956 308.296 9.956 308.296 48.356"
}), /*#__PURE__*/React.createElement("path", {
  className: "svg-mono",
  fill: "#000",
  fillRule: "nonzero",
  d: "M352.704,26.768 L352.704,45.108 C348.299621,47.721729 343.25692,49.0634032 338.136,48.984 C326.872,48.984 317.964,40.916 317.964,29.176 C317.964,17.436 326.976,9.316 338.608,9.316 C343.64,9.316 347.672,10.628 351.496,12.62 L347.776,19.796 C345.130672,18.4033572 342.189459,17.6666823 339.2,17.648 C331.548,17.648 327.464,22.416 327.464,29.176 C327.464,36.512 332.388,41.072 338.664,41.072 C341.492,41.072 342.908,40.756 344.324,40.024 L344.324,34.364 L336.616,34.364 L336.616,26.764 L352.704,26.768 Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "svg-mono",
  fill: "#000",
  fillRule: "nonzero",
  points: "395.008 49.088 371.848 28.288 371.848 48.356 362.94 48.356 362.94 9.424 364.14 9.212 386.988 29.856 386.988 9.948 395.896 9.948 395.896 48.932"
}));

var SvgHellosign = function SvgHellosign(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 58,
    viewBox: "0 0 396 58",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHellosign, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hellosign.c057d06b.svg";
export { ForwardRef as ReactComponent };